import * as Yup from 'yup';
import dokumenFormModel from './dokumenFormModel';

const {
  formField: {
    dokumen,
    nama,
    penerima,
    tglTerima
  }
} = dokumenFormModel;

export default Yup.object({
  [dokumen.name]: Yup.string().required(`${dokumen.requiredErrorMsg}`),
  [nama.name]: Yup.string().required(`${nama.requiredErrorMsg}`),
  [penerima.name]: Yup.string().required(`${penerima.requiredErrorMsg}`),
  [tglTerima.name]: Yup.string().required(`${tglTerima.requiredErrorMsg}`)
});
